var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('div',[_c('div',{staticClass:"d-flex justify-content-center"}),(_vm.detail)?_c('p',{staticClass:"mb-0"},[_vm._v(" Note sul ritiro: "),_c('strong',[_vm._v(_vm._s(_vm.detail)+" ")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }